/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplementStatus } from './SupplementStatus';
import {
    SupplementStatusFromJSON,
    SupplementStatusFromJSONTyped,
    SupplementStatusToJSON,
    SupplementStatusToJSONTyped,
} from './SupplementStatus';

/**
 * Base supplement record returned by the API.
 * @export
 * @interface Supplement
 */
export interface Supplement {
    /**
     * Unique supplement ID
     * @type {number}
     * @memberof Supplement
     */
    readonly id: number;
    /**
     * ID of the associated claim
     * @type {number}
     * @memberof Supplement
     */
    claimId: number;
    /**
     * ID of the associated comparison
     * @type {number}
     * @memberof Supplement
     */
    comparisonId: number;
    /**
     * Display name (auto-generated as "Supplement
     * @type {string}
     * @memberof Supplement
     */
    name: string;
    /**
     * 
     * @type {SupplementStatus}
     * @memberof Supplement
     */
    status: SupplementStatus;
    /**
     * System-managed workflow processing state
     * @type {string}
     * @memberof Supplement
     */
    workflowStatus: SupplementWorkflowStatusEnum;
    /**
     * Temporal workflow ID for SSE streaming
     * @type {string}
     * @memberof Supplement
     */
    workflowId?: string | null;
    /**
     * US state code (e.g., 'TX', 'AK') for building code justifications
     * @type {string}
     * @memberof Supplement
     */
    state?: string | null;
    /**
     * Overall AI confidence score (0.0 to 1.0)
     * @type {number}
     * @memberof Supplement
     */
    overallConfidenceScore?: number | null;
    /**
     * ID of the user who created this supplement
     * @type {number}
     * @memberof Supplement
     */
    readonly createdBy: number;
    /**
     * When the supplement was created
     * @type {Date}
     * @memberof Supplement
     */
    readonly createdAt: Date;
    /**
     * When the supplement was last updated
     * @type {Date}
     * @memberof Supplement
     */
    readonly updatedAt: Date;
}


/**
 * @export
 */
export const SupplementWorkflowStatusEnum = {
    Pending: 'pending',
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed'
} as const;
export type SupplementWorkflowStatusEnum = typeof SupplementWorkflowStatusEnum[keyof typeof SupplementWorkflowStatusEnum];


/**
 * Check if a given object implements the Supplement interface.
 */
export function instanceOfSupplement(value: object): value is Supplement {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('comparisonId' in value) || value['comparisonId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('workflowStatus' in value) || value['workflowStatus'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SupplementFromJSON(json: any): Supplement {
    return SupplementFromJSONTyped(json, false);
}

export function SupplementFromJSONTyped(json: any, ignoreDiscriminator: boolean): Supplement {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'comparisonId': json['comparisonId'],
        'name': json['name'],
        'status': SupplementStatusFromJSON(json['status']),
        'workflowStatus': json['workflowStatus'],
        'workflowId': json['workflowId'] == null ? undefined : json['workflowId'],
        'state': json['state'] == null ? undefined : json['state'],
        'overallConfidenceScore': json['overallConfidenceScore'] == null ? undefined : json['overallConfidenceScore'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function SupplementToJSON(json: any): Supplement {
    return SupplementToJSONTyped(json, false);
}

export function SupplementToJSONTyped(value?: Omit<Supplement, 'id'|'createdBy'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'comparisonId': value['comparisonId'],
        'name': value['name'],
        'status': SupplementStatusToJSON(value['status']),
        'workflowStatus': value['workflowStatus'],
        'workflowId': value['workflowId'],
        'state': value['state'],
        'overallConfidenceScore': value['overallConfidenceScore'],
    };
}

